@import '../../../theme.scss';

verdocs-template-create {
  font-family: $verdocs-primary-font;

  form {
    background-color: $verdocs-grey-4;
    padding: 12px;
    display: flex;
    flex-direction: column;

    .upload-box {
      box-sizing: border-box;
      width: 320px;
      text-align: center;
      padding: 44px 18px 66px;
      border: 2px dashed #979797;
      color: rgba(0, 0, 0, 0.54);

      &.drag-over {
        border: 2px solid $verdocs-deep-blue;
      }

      svg {
        width: 64px;
        fill: #5c6575;
      }
    }
  }

  p {
    color: $verdocs-grey-1;
    margin-top: 20px;
    font-size: 18px;
    font-weight: 500;
    overflow-wrap: anywhere;

    &.subscript {
      color: $verdocs-bg-4;
      font-size: 14px;
      margin: 20px;
    }
  }

  .loader-wrapper {
    background-color: $verdocs-grey-4;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    width: 320px;
    height: 320px;
    text-align: center;
    border: 2px dashed #979797;
    justify-content: flex-end;
  }

  .progress-wrapper {
    padding: 20px;
  }

  .buttons {
    display: flex;
    column-gap: 8px;
    margin-top: 16px;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;

    .flex-fill {
      flex: 1;
    }
  }

  ::placeholder {
    color: $verdocs-bg-2;
  }

  .error {
    margin: 20px 0;
    color: $verdocs-red-1;
  }
}
